export default {
  arnActiveTab: '',
}
